export default {
      id: "oc-switch-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-switch",
      toString: function () {
        return this.url;
      }
    }